import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { noop } from 'lodash';
import ButtonGroup from '@material-ui/core/ButtonGroup/ButtonGroup';
import {
  DetailHandle,
  DetailContext,
  DetailToolbarButton,
  UserContext,
  ConfirmDialog,
  DetailMode,
} from '@eas/common-web';
import { Requester } from '../../../common/models';
import { useRequesters } from './requesters-hook';
import { useStyles } from './requesters-styles';
import { RequesterPwChangeDialog } from './requesters-pw-dialog';
import { Permissions } from '../../../common/permissions';

export function RequestersToolbar() {
  const classes = useStyles();
  const { isExisting, source, onPersisted, mode } = useContext<
    DetailHandle<Requester>
  >(DetailContext);

  const {
    id,
    passwordChangeDialog,
    confirmDeactivateDialog,
    confirmActivateDialog,
    activate,
    deactivate,
    changePassword,
    openActivateDialog,
    openDeactivateDialog,
  } = useRequesters({ source, onPersisted });
  const { hasPermission } = useContext(UserContext);

  const isAdministrator = hasPermission(Permissions.ADMINISTRATOR);

  return (
    <>
      {isAdministrator && isExisting && mode === DetailMode.VIEW && (
        <>
          <ButtonGroup
            size="small"
            variant="outlined"
            className={classes.toolbarIndentLeft}
          >
            {source.data?.active ? (
              <DetailToolbarButton
                label={
                  <FormattedMessage
                    id="KS_O_REQUESTERS_TOOLBAR_BTN_DEACTIVATE"
                    defaultMessage="Deaktivovat"
                  />
                }
                tooltip={
                  <FormattedMessage
                    id="KS_O_REQUESTERS_TOOLBAR_TOOLTIP_DEACTIVATE"
                    defaultMessage="Uživatel se nebude moci přihlásit"
                  />
                }
                onClick={openDeactivateDialog}
              />
            ) : (
              <DetailToolbarButton
                label={
                  <FormattedMessage
                    id="KS_O_REQUESTERS_TOOLBAR_BTN_ACTIVATE"
                    defaultMessage="Aktivovat"
                  />
                }
                tooltip={
                  <FormattedMessage
                    id="KS_O_REQUESTERS_TOOLBAR_TOOLTIP_ACTIVATE"
                    defaultMessage="Uživatel se bude moci přihlásit"
                  />
                }
                onClick={openActivateDialog}
              />
            )}
            <DetailToolbarButton
              label={
                <FormattedMessage
                  id="KS_O_REQUESTERS_TOOLBAR_BTN_PW_CHANGE"
                  defaultMessage="Změnit heslo"
                />
              }
              tooltip={
                <FormattedMessage
                  id="KS_O_REQUESTERS_TOOLBAR_TOOLTIP_PW_CHANGE"
                  defaultMessage="Otevře dialog pro změnu hesla"
                />
              }
              onClick={changePassword}
            />
          </ButtonGroup>
          <RequesterPwChangeDialog ref={passwordChangeDialog} id={id!} />
          <ConfirmDialog
            ref={confirmDeactivateDialog}
            onConfirm={deactivate}
            onCancel={noop}
            title={
              <FormattedMessage
                id="KS_DEACTIVATE_REQUESTER_DIALOG_TITLE"
                defaultMessage="Varování"
              />
            }
            text={
              <FormattedMessage
                id="KS_DEACTIVATE_REQUESTER_DIALOG_TEXT"
                defaultMessage="Účet bude deaktivován. Uživatel se nebude moci přihlásit ke svému účtu. Skutečně chcete pokračovat?"
              />
            }
          />
          <ConfirmDialog
            ref={confirmActivateDialog}
            onConfirm={activate}
            onCancel={noop}
            title={
              <FormattedMessage
                id="KS_ACTIVATE_REQUESTER_DIALOG_TITLE"
                defaultMessage="Varování"
              />
            }
            text={
              <FormattedMessage
                id="KS_ACTIVATE_REQUESTER_DIALOG_TEXT"
                defaultMessage="Účet bude aktivován. Skutečně chcete pokračovat?"
              />
            }
          />
        </>
      )}
    </>
  );
}
